<template>
  <div class="page-wrapper">
    <b-row class="text-left d-flex">
      <b-col class="mb-3" sm="12" lg="6">
        <!-- Logo + Nome + Versão -->
        <div class="d-flex mb-5">
          <img
            width="50px"
            src="../assets/robo-klaus.svg"
            alt="Logo do Robô Klaus"
          />
          <div class="ml-3">
            <span class="titulo">Robô Klaus</span>
          </div>
        </div>

        <!-- Descrição do app -->
        <span class="titulo-section">DESCRIÇÃO</span>
        <p class="descricao mt-3">
          Faça upload de documentos fiscais que estão no seu computador para a
          nuvem Klaus somente apontando a pasta onde estão
        </p>

        <p>
          Perfeito para quem quer subir notas de saída e também para quem está
          migrando para a Klaus 🚚
        </p>

        <h5>Recursos do Robô Klaus</h5>
        <ul>
          <li>Seleção de diversas pastas</li>
          <li>Adição de múltiplas empresas</li>
          <li>Identificação automática dos documentos fiscais na pasta</li>
          <li>
            Minimizável, enquanto nosso aplicativo trabalha você pode seguir
            fazendo outras atividades
          </li>
          <li>Otimizado para os XMLs de saída</li>
        </ul>
        <!-- DESCOMENTAR QUANDO HOUVEREM SCREENSHOTS (Não esquecer de alterar os valores do src e do v-pswp das imagens) -->

        <!-- Galeria de screenshots
        <span class="titulo-section">SCREENSHOTS</span>
        <div class="galeria mt-3">
          <Photoswipe>
            <img
              class="d-block img-fluid w-100"
              :src="require('../assets/screenshots/robo-klaus-1.png')"
              v-pswp="require('../assets/screenshots/robo-klaus-1.png')"
            />
          </Photoswipe>
          <Photoswipe>
            <img
              class="d-block img-fluid w-100"
              :src="require('../assets/screenshots/robo-klaus-2.png')"
              v-pswp="require('../assets/screenshots/robo-klaus-2.png')"
            />
          </Photoswipe>
        </div>  -->
      </b-col>

    </b-row>

    <!-- Modal de download -->
    <modal-download-suite
      @fechar-modal="fecharModal"
      :visibilidade="isModalVisivel"
    />
  </div>
</template>

<script>
import ModalDownloadSuite from "../components/ModalDownloadSuite.vue";
import mixin from "../mixins/mixin";
import "../assets/theme.css";
export default {
  name: "RoboKlaus",
  components: {
    ModalDownloadSuite,
  },
  mixins: [mixin],
};
</script>
